import { Color } from '@diritto/common/style/color';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { isPC } from 'constants/layout';
import { ZIndex } from 'constants/zIndex';
import { ArrowIcon } from 'icons/ArrowIcon';
import React from 'react';

type SectionSlideButtonProps = {
  handlePrevSlide: () => void;
  handleNextSlide: () => void;
  showSlideButton: { left: boolean; right: boolean };
  extraButtonTop?: number;
};

const ButtonSize = 40;
export const SectionSlideButton = ({
  handlePrevSlide,
  handleNextSlide,
  showSlideButton,
  extraButtonTop = 0,
}: SectionSlideButtonProps) => (
  <>
    <StyledPrevButton onClick={handlePrevSlide} show={showSlideButton.left} extraButtonTop={extraButtonTop}>
      <ArrowIcon color={Color.Gray400} className="w-[18px] h-[18px]" />
    </StyledPrevButton>
    <StyledNextButton onClick={handleNextSlide} show={showSlideButton.right} extraButtonTop={extraButtonTop}>
      <ArrowIcon direction="right" color={Color.Gray400} className="w-[18px] h-[18px]" />
    </StyledNextButton>
  </>
);

const StyledSlideButton = styled.div(
  ({ extraButtonTop }: { extraButtonTop: number }) => css`
    position: absolute;
    width: ${ButtonSize}px;
    height: ${ButtonSize}px;
    top: calc(50% - ${ButtonSize}px / 2 + ${extraButtonTop}px);
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
    border-radius: 48px;
    background: ${Color.White};
    z-index: ${ZIndex.HomeSectionPrevNextButton};
    cursor: pointer;
    display: none;
    justify-content: center;
    align-items: center;
    transition: opacity 0.2s ease-in-out;
    transition-delay: 0.1s;
    @media (${isPC}) {
      display: flex;
    }
  `,
);

const StyledPrevButton = styled(StyledSlideButton)(
  ({ show }: { show: boolean }) => css`
    left: 0;
    opacity: ${show ? 1 : 0};
    pointer-events: ${show ? 'auto' : 'none'};
    cursor: ${show ? 'pointer' : 'default'};
  `,
);

const StyledNextButton = styled(StyledSlideButton)(
  ({ show }: { show: boolean }) => css`
    right: 0;
    opacity: ${show ? 1 : 0};
    pointer-events: ${show ? 'auto' : 'none'};
    cursor: ${show ? 'pointer' : 'default'};
  `,
);
